module.exports = __webpack_public_path__ + "img/hr-sand.b57eea03.png";